import { scrollToTop } from "@src/utils/scrollTo";
import "./backToTop.css";

const hiddenScrollSize = 200;
export default function setupBackToTop() {
  const element = document.querySelector("#back-to-top");
  if (!element || !window) return;
  element.addEventListener("click", scrollToTop);
  window.addEventListener("scroll", () => {
    if (window.scrollY > hiddenScrollSize) {
      element.classList.remove("hidden");
    } else {
      element.classList.add("hidden");
    }
  });
}
